import { render, staticRenderFns } from "./Precept.vue?vue&type=template&id=7be66da3&"
import script from "./Precept.vue?vue&type=script&lang=js&"
export * from "./Precept.vue?vue&type=script&lang=js&"
import style0 from "./Precept.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports